/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCategoryNotificationConfiguration } from './InternalApiCategoryNotificationConfiguration';
import {
    InternalApiCategoryNotificationConfigurationFromJSON,
    InternalApiCategoryNotificationConfigurationFromJSONTyped,
    InternalApiCategoryNotificationConfigurationToJSON,
    InternalApiCategoryNotificationConfigurationToJSONTyped,
} from './InternalApiCategoryNotificationConfiguration';

/**
 * command update user notification configuration for alert rfi messages
 * @export
 * @interface InternalApiUpdateUserAlertRfiMessageNotifications
 */
export interface InternalApiUpdateUserAlertRfiMessageNotifications {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiUpdateUserAlertRfiMessageNotifications
     */
    categoryIds: Array<string>;
    /**
     * 
     * @type {Array<InternalApiCategoryNotificationConfiguration>}
     * @memberof InternalApiUpdateUserAlertRfiMessageNotifications
     */
    categoryConfigurations?: Array<InternalApiCategoryNotificationConfiguration>;
}

/**
 * Check if a given object implements the InternalApiUpdateUserAlertRfiMessageNotifications interface.
 */
export function instanceOfInternalApiUpdateUserAlertRfiMessageNotifications(value: object): value is InternalApiUpdateUserAlertRfiMessageNotifications {
    if (!('categoryIds' in value) || value['categoryIds'] === undefined) return false;
    return true;
}

export function InternalApiUpdateUserAlertRfiMessageNotificationsFromJSON(json: any): InternalApiUpdateUserAlertRfiMessageNotifications {
    return InternalApiUpdateUserAlertRfiMessageNotificationsFromJSONTyped(json, false);
}

export function InternalApiUpdateUserAlertRfiMessageNotificationsFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiUpdateUserAlertRfiMessageNotifications {
    if (json == null) {
        return json;
    }
    return {
        
        'categoryIds': json['categoryIds'],
        'categoryConfigurations': json['categoryConfigurations'] == null ? undefined : ((json['categoryConfigurations'] as Array<any>).map(InternalApiCategoryNotificationConfigurationFromJSON)),
    };
}

export function InternalApiUpdateUserAlertRfiMessageNotificationsToJSON(json: any): InternalApiUpdateUserAlertRfiMessageNotifications {
    return InternalApiUpdateUserAlertRfiMessageNotificationsToJSONTyped(json, false);
}

export function InternalApiUpdateUserAlertRfiMessageNotificationsToJSONTyped(value?: InternalApiUpdateUserAlertRfiMessageNotifications | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'categoryIds': value['categoryIds'],
        'categoryConfigurations': value['categoryConfigurations'] == null ? undefined : ((value['categoryConfigurations'] as Array<any>).map(InternalApiCategoryNotificationConfigurationToJSON)),
    };
}

